export const alertUnderConstruction = (): void => {
  window.alert(
    "🚧 We're still building this content - why don't you try something else?"
  );
};
